import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  title: theme => ({
    marginTop: 60,
    fontSize: 20,
    lineHeight: 28,
    textAlign: 'center',
    color: theme.colors.errorMessageColor,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  }),
  subtitle: theme => ({
    marginTop: 16,
    fontSize: 18,
    lineHeight: 24,
    textAlign: 'center',
    color: theme.colors.errorMessageColor,
    fontFamily: Fonts.type.VFFont,
    fontWeight: '200',
  }),
});
